export const useAnalytics = () => {
  const sendParams = (parameters: Record<string, any> = {}) => {
    if (typeof ym !== "undefined") {
      ym(102909195, "params", parameters);
    }

    if (typeof gtag !== "undefined") {
      gtag("set", "user_properties", parameters);

      gtag("event", "site_variant_detected", {
        site_version: parameters.site_version,
      });
    }

    console.log("Analytics paraments version sent:", { parameters });
  };

  const sendEvent = (eventName: string, parameters: Record<string, any> = {}) => {
    // Google Analytics 4
    if (typeof gtag !== "undefined") {
      gtag("event", eventName, parameters);
    }

    // Яндекс Метрика
    if (typeof ym !== "undefined") {
      // Для Яндекс Метрики используем reachGoal
      ym(102909195, "reachGoal", eventName, parameters);
    }

    // Логирование для отладки
    console.log("Analytics event sent:", { eventName, parameters });
  };

  const trackSignUpStarted = (elementName: string) => {
    sendEvent("site_sign_up_started", {
      element_name: elementName,
    });
  };

  const trackModalOpen = (modalName: string, elementName?: string) => {
    sendEvent("modal_open", {
      modal_name: modalName,
      element_name: elementName,
    });
  };

  const trackButtonClick = (buttonName: string, location?: string) => {
    sendEvent("button_click", {
      button_name: buttonName,
      location: location,
    });
  };

  return {
    sendEvent,
    trackSignUpStarted,
    trackModalOpen,
    trackButtonClick,
    sendParams,
  };
};
